













import Vue from 'vue';
import Component from 'vue-class-component';
import store from '@/store';
import {Watch} from 'vue-property-decorator';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import AlertDialog from '@/views/AlertDialog.vue';

@Component({
  components: {AlertDialog}
})
export default class WelcomeTemplate extends Vue {

  private static readonly USER_WORKSTATION_ENDPOINT = '/identity/v0/users/workstation';

  $refs!: {
    alert: AlertDialog
  };

  user: DisguiseDto.UserDataDto = store.state.user;

  @Watch('$store.state.user') onUserUpdated(value: DisguiseDto.UserDataDto) {
    this.user = value;
    HTTP_SERVICE_INSTANCE.getAxios().post(WelcomeTemplate.USER_WORKSTATION_ENDPOINT)
        .catch((invalid) => {
          if (invalid.response) {
            if (invalid.response.status === 404) {
              this.$refs.alert.open('ACHTUNG', ['Fehlende Workstation! Bitte wenden Sie sich an Ihren Administrator!']);
            } else if (invalid.response.status === 409) {
              this.$refs.alert.open('ACHTUNG', ['Workstation unbekannt! Bitte wenden Sie sich an Ihren Administrator!']);
            }
          }
        });
  }

}
